export default "__VITE_ASSET__LN6DZrn$__"